export default __webpack_public_path__ + "images/8a7fad0aab3e60e293dfacec4cb0d11b-guardian.svg";